import Checkbox from "components/ui/Checkbox";
import ImagePreview from "components/ui/ImagePreview";
import {
  MASTER_TENANT,
  PRODUCT,
  PRODUCT_CREATOR_PAGE,
} from "constants/commonConstants";
import {
  APPROVED_STATUS,
  DRAFT_STATUS,
  PENDING_STATUS,
} from "constants/productConstants";
import { useApp } from "context/appContext";
import usePermissions from "hooks/usePermissions";
import { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { createArrayWithValues } from "utils/helper";

export default function Images({
  images,
  setImagesToDelete,
  productStatus = "",
  imagesToDelete,
}) {
  const { canRead, canUpdate, canAccess } = usePermissions();
  const { tenant, isProductApprovalEnabled } = useApp();
  const [searchParams] = useSearchParams();
  const fromPage = searchParams.get("from");

  const cannotEdit =
    isProductApprovalEnabled &&
    productStatus &&
    productStatus !== APPROVED_STATUS
      ? fromPage !== "approver" &&
        (productStatus === PENDING_STATUS ||
          (productStatus === DRAFT_STATUS && !canAccess(PRODUCT_CREATOR_PAGE)))
      : (canRead(PRODUCT) && !canUpdate(PRODUCT)) || tenant === MASTER_TENANT;

  return (
    <div className="p-20">
      <div className="grid grid-cols-5 py-20">
        <div className="flex items-center justify-center">
          <Checkbox
            onChange={({ target: { checked } }) => {
              if (checked)
                setImagesToDelete(
                  createArrayWithValues(images?.imagesData?.length)
                );
              else setImagesToDelete([]);
            }}
            disabled={cannotEdit}
            checked={imagesToDelete.length === images?.imagesData?.length}
            label={"Delete Images"}
            labelRight
          />
        </div>
        <div className="font-bold text-textColor">Small</div>
        <div className="font-bold text-textColor">Medium</div>
        <div className="font-bold text-textColor">Large</div>
        <div className="font-bold text-textColor">Sequence</div>
      </div>
      <div className="grid grid-cols-5 gap-y-20 py-20">
        {images?.imagesData?.map(({ url }, i) => {
          return (
            <Fragment key={i}>
              <div
                key={`checkbox_${i}`}
                className="flex items-center justify-center"
              >
                <Checkbox
                  disabled={cannotEdit}
                  onChange={({ target: { checked } }) => {
                    if (checked) {
                      setImagesToDelete((curr) => [...curr, i]);
                    } else
                      setImagesToDelete((curr) =>
                        curr.filter((imgIndex) => imgIndex !== i)
                      );
                  }}
                  checked={imagesToDelete.includes(i)}
                />
              </div>
              {url?.smallUrl ? (
                <div key={`smallUrl_${i}`} className="flex justify-center">
                  <ImagePreview url={url?.smallUrl} />
                </div>
              ) : (
                <div></div>
              )}
              {url?.mediumUrl ? (
                <div
                  key={`mediumUrl_${i}`}
                  className="flex justify-center items-center"
                >
                  <ImagePreview url={url?.mediumUrl} />
                </div>
              ) : (
                <div></div>
              )}
              {url?.largeUrl ? (
                <div
                  key={`largeUrl_${i}`}
                  className="flex justify-center items-center"
                >
                  <ImagePreview url={url?.largeUrl} />
                </div>
              ) : (
                <div></div>
              )}
              <div
                key={`order_${i}`}
                className="flex items-center justify-center"
              >
                {images?.imagesData?.[i]?.order}
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
